
import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import PropTypes from 'prop-types';
import { IconButton, InputAdornment, TextField } from "@mui/material";

import axios from "../../utils/axios";
import Checkbox from './Checkbox';
import Modal from "./CustomModal";
import Select from "./Select";
import Button from "./Button";
import WalkthroughOverlay from "./WalkthroughOverlay";
import Switch from "./SwitchBtn";

import {
    updateCurrentWalkthroughStep as updateCurrentWalkthroughStepRequest,
    updateWalkthroughFlows as updateWalkthroughFlowsRequest,
    fetchPreScreeningBots as fetchPreScreeningBotsRequest,
    updateCurrentWalkthroughType as updateCurrentWalkthroughTypeRequest
} from '../../actions/app';
import { getCompanyFeatures, getCurrentWalkthroughStep, getCurrentWalkthroughType, getPreScreeningBots, getSaasPlanDetails, getUserPlan } from "../../selectors/app";
import { checkCompanyFeatureAccess, checkUserPlanAccess } from "../../utils/featureAccess";

import clockIcon from '../../assets/Icons/Time.png';
import ArrowUp from '../../assets/Icons/arrow-up.svg';
import ArrowDown from '../../assets/Icons/arrow-down.svg';
import { useEffect } from "react";
import { redirectUnauthorisedUser } from "../../helper/helperFunction";
import { useLocation } from "react-router-dom";
import CustomDateTimePicker from "./CustomDateTimePicker";

const CustomInviteModal = (props) => {
    const { open, onClose, companyFeatures, userPlan, saasPlanDetails, preScreeningBots, setErrMsg, handleSnackClick, currentWalkthroughStep, currentWalkthroughType, updateCurrentWalkthroughStep, change, setChange, tempInvObjArr, showWalkthrough, tempRemObjArr, mailList, setMailList, updateCurrentWalkthroughType, updateWalkthroughFlows, tempPsInv, fetchPreScreeningBots } = props;

    const location = useLocation();
    const todaysDate = new Date();
    const mediaQueryMobile = window.matchMedia('(max-width: 768px)');
    const allowPreScreening = checkCompanyFeatureAccess(companyFeatures, 'preScreening', null) && checkUserPlanAccess(userPlan.name, saasPlanDetails, 'preScreening', null);
    const [scheduleInviteParams, setScheduleInviteParams] = useState({
        date: todaysDate.toISOString().slice(0, 10),
        time: todaysDate.getHours() + ":" + todaysDate.getMinutes(),
    });
    const [scheduleInviteModal, setScheduleInviteModal] = useState(false);
    const [remindCheckBox, setRemindCheckBox] = useState(false);
    const [reminderSchedule, setReminderSchedule] = useState(1);
    const [remindRepeatCheckBox, setRemindRepeatCheckBox] = useState(false);
    const [selectedInvTemp, setSelectedInvTemp] = useState(null);
    const [selectedPsInvTemp, setSelectedPsInvTemp] = useState(null)
    const [selectedAutoRemTemp, setSelectedAutoRemTemp] = useState(null);
    const [selectedPreScreeningBot, setSelectedPreScreeningBot] = useState(null);
    const [autoRemindHours, setAutoRemindHours] = useState(24);
    const [deadlineInvite, setDeadlineInvite] = useState(5);
    const [testStartDate, setTestStartDate] = useState(0);
    const [deadlineCheckBox, setDeadlineCheckBox] = useState(false);
    const [startDateCheckbox, setStartDateCheckbox] = useState(false);
    const [preScreeningCheckBox, setPreScreeningCheckBox] = useState(false);
    const [showScheduleInvite, setShowScheduleInvite] = useState(false);
    const [prescreeningBotsObjArr, setPrescreeningBotsObjArr] = useState([]);
    const [prescreeningTempObjArr, setPrescreeningTempObjArr] = useState([]);
    const [convo, setConvo] = useState([]);
    const [bot, setBot] = useState();
    const [workflowProductId, setWorkFlowProductId] = useState();

    const onOpenScheduleInviteModal = () => setScheduleInviteModal(true);

    const onCloseScheduleInviteModal = () => setScheduleInviteModal(false);

    const sendInvteSchedule = () => {
        if (remindCheckBox && autoRemindHours === '') {
            setErrMsg('Please add the time after which reminder mails should be triggered.');
            handleSnackClick();
        } else if (preScreeningCheckBox && (!selectedPreScreeningBot || selectedPreScreeningBot == null)) {
            setErrMsg('Please select a pre-screening bot, or disable the option of adding pre-screening stage.');
            handleSnackClick();
        } else if (preScreeningCheckBox && (selectedPsInvTemp === null)) {
            setErrMsg('Please select a pre-screening template.');
            handleSnackClick();
        } else {
            const uri = "/company/workflow/candidate/schedule-invite";
            let sstime = scheduleInviteParams.date + ' ' + scheduleInviteParams.time + ':00'
            let stime = new Date(sstime)
            const getData = {
                workflowId: location.state.workflowId,
                bot: bot,
                stime: stime.getTime(),
                emailIndex: selectedInvTemp,
                candlist: mailList,
                remind: (remindCheckBox ?
                    { shouldRemind: true, autoRemTemplate: selectedAutoRemTemp, autoRemHours: autoRemindHours, rescheduleReminder: remindRepeatCheckBox ? reminderSchedule : null }
                    :
                    { shouldRemind: false, autoRemTemplate: null, autoRemHours: null, rescheduleReminder: null }),
                deadline: (deadlineCheckBox ?
                    { hasDeadline: true, deadlineInvite }
                    :
                    { hasDeadline: false, deadlineInvite: null }),
                startDate: startDateCheckbox ?
                    { hasStartDate: true, testStartDate: testStartDate }
                    :
                    { hasStartDate: false, testStartDate: null },
                preScreening: preScreeningCheckBox ?
                    { sendPreScreening: true, preScreeningBot: selectedPreScreeningBot }
                    :
                    { sendPreScreening: false }
            };

            const candInviteSettings = {
                remindCheckBox,
                autoRemTemplate: selectedAutoRemTemp,
                autoRemHours: autoRemindHours,
                remindRepeatCheckBox,
                rescheduleReminder: reminderSchedule,
                deadlineCheckBox,
                deadlineInvite,
                preScreeningCheckBox,
                preScreeningBot: selectedPreScreeningBot,
                inviteTemplate: selectedInvTemp,
                prescreeningInviteTemplate: selectedPsInvTemp
            }

            axios.post(`/workflow/inviteSettings/${location.state.workflowId}`, candInviteSettings)
            .then((res) => {
                const {
                    remindCheckBox,
                    autoRemTemplate,
                    autoRemHours,
                    remindRepeatCheckBox,
                    rescheduleReminder,
                    deadlineCheckBox,
                    deadlineInvite,
                    preScreeningCheckBox,
                    preScreeningBot,
                    inviteTemplate,
                    prescreeningInviteTemplate
                } = res.data;
                
                setRemindCheckBox(remindCheckBox ?? false);
                setSelectedAutoRemTemp(autoRemTemplate ?? null);
                setAutoRemindHours(autoRemHours ?? 24);
                setRemindRepeatCheckBox(remindRepeatCheckBox ?? false);
                setReminderSchedule(rescheduleReminder ?? 1);
                setDeadlineCheckBox(deadlineCheckBox ?? false);
                setDeadlineInvite(deadlineInvite ?? 5);
                setPreScreeningCheckBox(preScreeningCheckBox ?? false);
                setSelectedPreScreeningBot(preScreeningBot ?? null);
                setSelectedInvTemp(inviteTemplate ?? null);
                setSelectedPsInvTemp(prescreeningInviteTemplate ?? null);
            })
            .catch((err) => console.log(err));

            axios.post(uri, JSON.stringify(getData), { headers: { 'Content-Type': 'application/json' } })
                .then(() => {
                    if (change) {
                        setChange(change + 1);
                    }
                    setMailList([]);
                    onCloseModal3();
                    onCloseScheduleInviteModal();
                })
                .catch((err) => {
                    console.log(err);
                    redirectUnauthorisedUser(err, history);
                });
        }
    }

    const onCloseModal3 = () => {
        setRemindCheckBox(false);
        setSelectedInvTemp(null);
        setSelectedAutoRemTemp(null)
        setAutoRemindHours(24);
        setShowScheduleInvite(false);
        setPreScreeningCheckBox(false);
        setSelectedPreScreeningBot(null);
        setSelectedPsInvTemp(null);
        setDeadlineCheckBox(false);
        setDeadlineInvite(5);
        onClose();
    }

    const handleRemindCheckBox = (event) => {
        setRemindCheckBox(event.target.checked);
        if (currentWalkthroughStep > 0 && currentWalkthroughType === 'invite') {
            updateCurrentWalkthroughStep(currentWalkthroughStep + 1);
        }
    };

    const handleDeadlineCheckBox = (event) => {
        setDeadlineCheckBox(event.target.checked);
        if (currentWalkthroughStep === 11 && currentWalkthroughType === 'invite') {
            updateCurrentWalkthroughStep(0);
            updateCurrentWalkthroughType('');
            let wArr = [];
            if (localStorage.getItem('walkthroughFlows')) {
                wArr = JSON.parse(localStorage.getItem('walkthroughFlows'));

            }
            wArr.push('invite');
            localStorage.setItem('walkthroughFlows', JSON.stringify(wArr));
            updateWalkthroughFlows(wArr);
        }
    };

    const handleStartDateCheckbox = (event) => {
        setStartDateCheckbox(event.target.checked);
        if (currentWalkthroughStep === 11 && currentWalkthroughType === 'invite') {
            updateCurrentWalkthroughStep(0);
            updateCurrentWalkthroughType('');
            let wArr = [];
            if (localStorage.getItem('walkthroughFlows')) {
                wArr = JSON.parse(localStorage.getItem('walkthroughFlows'));

            }
            wArr.push('invite');
            localStorage.setItem('walkthroughFlows', JSON.stringify(wArr));
            updateWalkthroughFlows(wArr);
        }
    };

    const handlePreScreeningCheckBox = (event) => {
        setPreScreeningCheckBox(event.target.checked);
        if (currentWalkthroughStep > 0 && currentWalkthroughType === 'invite') {
            updateCurrentWalkthroughStep(currentWalkthroughStep + 1);
        }
    };

    const sendTest = () => {
        if (remindCheckBox && autoRemindHours === '') {
            setErrMsg('Please add the time after which reminder mails should be triggered.');
            handleSnackClick();
        } else if (preScreeningCheckBox && (!selectedPreScreeningBot || selectedPreScreeningBot == null)) {
            setErrMsg('Please select a pre-screening bot, or disable the option of adding pre-screening stage.');
            handleSnackClick();
        } else if (preScreeningCheckBox && (selectedPsInvTemp === null)) {
            setErrMsg('Please select a pre-screening template.');
            handleSnackClick();
        } else {
            const uri = "/company/workflow/candidate/invite";
            const getData = {
                workflowId: location.state.workflowId,
                bot: bot,
                emailIndex: selectedInvTemp,
                candlist: mailList,
                remind: (remindCheckBox ?
                    { shouldRemind: true, autoRemTemplate: selectedAutoRemTemp, autoRemHours: autoRemindHours, rescheduleReminder: remindRepeatCheckBox ? reminderSchedule : null }
                    :
                    { shouldRemind: false, autoRemTemplate: null, autoRemHours: null, rescheduleReminder: null }),
                deadline: (deadlineCheckBox ?
                    { hasDeadline: true, deadlineInvite: deadlineInvite }
                    :
                    { hasDeadline: false, deadlineInvite: null }),
                startDate: startDateCheckbox ? 
                    { hasStartDate: true, testStartDate: testStartDate } 
                    : 
                    { hasStartDate: false, testStartDate: null },    
                preScreening: preScreeningCheckBox ?
                    { sendPreScreening: true, preScreeningBot: selectedPreScreeningBot }
                    :
                    { sendPreScreening: false }
            };

            const candInviteSettings = {
                remindCheckBox,
                autoRemTemplate: selectedAutoRemTemp,
                autoRemHours: autoRemindHours,
                remindRepeatCheckBox,
                rescheduleReminder: reminderSchedule,
                deadlineCheckBox,
                deadlineInvite,
                preScreeningCheckBox,
                preScreeningBot: selectedPreScreeningBot,
                inviteTemplate: selectedInvTemp,
                prescreeningInviteTemplate: selectedPsInvTemp
            }

            axios.post(`/workflow/inviteSettings/${location.state.workflowId}`, candInviteSettings)
            .then((res) => {
                const {
                    remindCheckBox,
                    autoRemTemplate,
                    autoRemHours,
                    remindRepeatCheckBox,
                    rescheduleReminder,
                    deadlineCheckBox,
                    deadlineInvite,
                    preScreeningCheckBox,
                    preScreeningBot,
                    inviteTemplate,
                    prescreeningInviteTemplate
                } = res.data;

                setRemindCheckBox(remindCheckBox ?? false);
                setSelectedAutoRemTemp(autoRemTemplate ?? null);
                setAutoRemindHours(autoRemHours ?? 24);
                setRemindRepeatCheckBox(remindRepeatCheckBox ?? false);
                setReminderSchedule(rescheduleReminder ?? 1);
                setDeadlineCheckBox(deadlineCheckBox ?? false);
                setDeadlineInvite(deadlineInvite ?? 5);
                setPreScreeningCheckBox(preScreeningCheckBox ?? false);
                setSelectedPreScreeningBot(preScreeningBot ?? null);
                setSelectedInvTemp(inviteTemplate ?? null);
                setSelectedPsInvTemp(prescreeningInviteTemplate ?? null);
            })
            .catch((err) => console.log(err));

            axios.post(uri, JSON.stringify(getData), { headers: { 'Content-Type': 'application/json' } })
                .then(() => {
                    if (change) {
                        setChange(change + 1);
                    }
                    setMailList([]);
                    onCloseModal3();
                })
                .catch((err) => {
                    console.log(err);
                    redirectUnauthorisedUser(err, history);
                });
        }
    }

    const handleInviteModalValidation = () => {
        if (selectedInvTemp == null) return true;
        else {
            if (!remindCheckBox) {
                return false;
            } else if (remindCheckBox) {
                if (selectedAutoRemTemp == null) return true;
                else return false;
            }
        }
    }

    useEffect(() => {
        const psboArr = [];
        preScreeningBots.forEach((psb) => {
            psboArr.push({
                label: psb.name,
                value: psb._id
            })
        });

        setPrescreeningBotsObjArr([...psboArr]);
    }, [preScreeningBots]);

    useEffect(() => {
        const pstoa = [];
        tempPsInv.forEach((tpi, index) => {
            pstoa.push({
                label: tpi.name,
                value: index
            })
        });

        setPrescreeningTempObjArr([...pstoa]);
    }, [tempPsInv]);

    useEffect(() => {
        axios.get('/bot/all').then((response) => {
            if (response.data.length > 0) {
                setConvo(response.data);
            }
        }).catch((err) => {
            console.log(err);
            redirectUnauthorisedUser(err, history);
        });
        fetchPreScreeningBots({ history });

        axios.get(`/workflow/inviteSettings/${location.state.workflowId}`)
        .then((res) => {
            const {
                remindCheckBox,
                autoRemTemplate,
                autoRemHours,
                remindRepeatCheckBox,
                rescheduleReminder,
                deadlineCheckBox,
                deadlineInvite,
                preScreeningCheckBox,
                preScreeningBot,
                inviteTemplate,
                prescreeningInviteTemplate
            } = res.data;

            setRemindCheckBox(remindCheckBox ?? false);
            setSelectedAutoRemTemp(autoRemTemplate ?? null);
            setAutoRemindHours(autoRemHours ?? 24);
            setRemindRepeatCheckBox(remindRepeatCheckBox ?? false);
            setReminderSchedule(rescheduleReminder ?? 1);
            setDeadlineCheckBox(deadlineCheckBox ?? false);
            setDeadlineInvite(deadlineInvite ?? 5);
            setPreScreeningCheckBox(preScreeningCheckBox ?? false);
            setSelectedPreScreeningBot(preScreeningBot ?? null);
            setSelectedInvTemp(inviteTemplate ?? null);
            setSelectedPsInvTemp(prescreeningInviteTemplate ?? null);
        })
        .catch(() => console.log('Error in fetching candidate invite settings'));
    }, []);

    useEffect(() => {
        if (open) {
            convo.forEach((convoItem) => {
                if (workflowProductId.isCustom) {
                    if (convoItem.productId === workflowProductId.customId) {
                        setBot(convoItem);
                    }
                } else if (workflowProductId.isMegacase) {
                    if (convoItem.productId === workflowProductId.role) {
                        setBot(convoItem);
                    }
                } else {
                    if (convoItem.productId === workflowProductId) {
                        setBot(convoItem);
                    }
                }
            });
        }
    }, [open]);

    useEffect(() => {
        axios.get(("/workflow/" + location.state.workflowId))
            .then((res) => {
                setWorkFlowProductId(res.data.productId);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [location.state.workflowId]);

    return (
        <>
            <Modal open={open} onClose={onClose} classNames={{ modal: 'invitationModal' }} center>
                <p className="modal-heading-workflow">
                    Customise Invitation
                </p>
                <div
                    className="invitationModal__wrapper"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && !handleInviteModalValidation()) {
                            e.preventDefault();
                            sendTest();
                        }
                    }}
                >
                    <div style={{ margin: "15px 0", borderRadius: 25, zIndex: currentWalkthroughStep === 8 ? 1000 : '', position: 'relative' }}>
                        <Select
                            id="inviteStep8"
                            label="Select invitation template"
                            selectedValue={tempInvObjArr.find(e => e.value === selectedInvTemp)?.label || ''}
                            onChangeSelect={(val) => {
                                setSelectedInvTemp(val.value);
                                if (currentWalkthroughStep > 0 && currentWalkthroughType === 'invite') {
                                    updateCurrentWalkthroughStep(currentWalkthroughStep + 1);
                                }
                            }}
                            styles={{
                                root: {
                                    borderRadius: 25,
                                    border: '1px solid #bbb',
                                    width: '100%',
                                    padding: mediaQueryMobile.matches ? '0.3rem 0 0.3rem 1rem' : '0.3rem 0'
                                },
                                wrapper: {
                                    borderBottom: 'unset'
                                }
                            }}
                            dropdownData={tempInvObjArr}
                        />
                    </div>
                    <hr style={{ margin: mediaQueryMobile.matches ? '0 0 10px 0' : '20px 0', width: '100%', border: 0, height: 0, borderTop: '1px solid rgb(0, 0, 0, 0.12)' }} />
                    {allowPreScreening ? (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: mediaQueryMobile.matches ? 16 : preScreeningCheckBox ? 16 : 30, position: 'relative' }}>
                            <div>
                                <p style={{ fontSize: mediaQueryMobile.matches ? 16 : 18, fontWeight: 'bold' }}>Pre-screening</p>
                                <h4 style={{ color: "rgb(150,150,150)", fontWeight: "400" }}>Send pre-screening invite</h4>
                            </div>
                            <div style={{ alignSelf: 'flex-start', zIndex: currentWalkthroughStep === 9 ? 1000 : '', position: 'relative' }}>
                                <Switch
                                    id="inviteStep9"
                                    checked={preScreeningCheckBox}
                                    onChange={handlePreScreeningCheckBox}
                                />
                            </div>
                        </div>
                    ) : null}
                    {
                        preScreeningCheckBox ? (
                            <div style={{ display: 'flex', alignItems: 'center', flexDirection: mediaQueryMobile.matches ? 'column' : 'row', justifyContent: 'center' }}>
                                <div style={{ minWidth: mediaQueryMobile.matches ? '100%' : 230, margin: mediaQueryMobile.matches ? '0 0 8px 0' : '0 16px 0 0' }}>
                                    <Select
                                        label="Select pre-screening bot"
                                        selectedValue={prescreeningBotsObjArr.find(e => e.value === selectedPreScreeningBot)?.label || ''}
                                        onChangeSelect={(val) => setSelectedPreScreeningBot(val.value)}
                                        styles={{
                                            root: {
                                                borderRadius: 25,
                                                border: '1px solid #bbb',
                                                width: '100%',
                                                padding: mediaQueryMobile.matches ? '0.3rem 0 0.3rem 1rem' : '0.3rem 0'
                                            },
                                            wrapper: {
                                                borderBottom: 'unset'
                                            }
                                        }}
                                        dropdownAddItem={{ link: '/prescreening/dashboard', text: 'Add Pre-screening bot' }}
                                        dropdownData={prescreeningBotsObjArr}
                                    />
                                </div>
                                <div style={{ minWidth: 230, borderRadius: 25, width: mediaQueryMobile.matches ? '100%' : 'unset', margin: mediaQueryMobile.matches ? '0 0 16px 0' : 0 }}>
                                    <Select
                                        label="Select pre-screening template"
                                        selectedValue={prescreeningTempObjArr.find(e => e.value === selectedPsInvTemp)?.label || ''}
                                        onChangeSelect={(val) => setSelectedPsInvTemp(val.value)}
                                        styles={{
                                            root: {
                                                borderRadius: 25,
                                                border: '1px solid #bbb',
                                                width: '100%',
                                                padding: mediaQueryMobile.matches ? '0.3rem 0 0.3rem 1rem' : '0.3rem 0'
                                            },
                                            wrapper: {
                                                borderBottom: 'unset'
                                            }
                                        }}
                                        dropdownData={prescreeningTempObjArr}
                                    />
                                </div>
                            </div>
                        ) : null
                    }
                    <hr style={{ margin: mediaQueryMobile.matches ? '0 0 10px 0' : '20px 0', width: '100%', border: 0, height: 0, borderTop: '1px solid rgb(0, 0, 0, 0.12)' }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: mediaQueryMobile.matches ? 16 : remindCheckBox ? 16 : 30, marginTop: 20, position: 'relative' }}>
                        <div>
                            <p style={{ fontSize: mediaQueryMobile.matches ? 16 : 18, fontWeight: 'bold' }}>Auto-reminder</p>
                            <h4 style={{ color: "rgb(150,150,150)", fontWeight: "400" }}>Schedule reminder mails</h4>
                        </div>
                        <div style={{ alignSelf: 'flex-start', zIndex: currentWalkthroughStep === 10 ? 1000 : '', position: 'relative' }}>
                            <Switch
                                id="inviteStep10"
                                checked={remindCheckBox}
                                onChange={handleRemindCheckBox}
                            />
                        </div>
                    </div>
                    {remindCheckBox ? (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: mediaQueryMobile.matches ? 'flex-start' : 'center', marginBottom: mediaQueryMobile.matches ? 8 : 20, flexDirection: mediaQueryMobile.matches ? 'column' : 'row' }}>
                                <div style={{ minWidth: mediaQueryMobile.matches ? '100%' : 230 }}>
                                    <Select
                                        id="manageInvitation-selector-10"
                                        label="Select reminder template"
                                        selectedValue={tempRemObjArr.find(e => e.value === selectedAutoRemTemp)?.label || ''}
                                        onChangeSelect={(val) => setSelectedAutoRemTemp(val.value)}
                                        styles={{
                                            root: {
                                                borderRadius: 25,
                                                border: '1px solid #bbb',
                                                width: '100%',
                                                padding: mediaQueryMobile.matches ? '0.3rem 0 0.3rem 1rem' : '0.3rem 0'
                                            },
                                            wrapper: {
                                                borderBottom: 'unset'
                                            }
                                        }}
                                        dropdownData={tempRemObjArr}
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', margin: mediaQueryMobile.matches ? '16px 0 8px 0' : 0 }}>
                                    <p style={{ marginRight: "10px" }}>Remind After</p>
                                    <TextField
                                        style={{ width: "90px" }}
                                        variant="standard"
                                        value={autoRemindHours}
                                        onChange={(e) => setAutoRemindHours(e.target.value)}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <img
                                                        src={clockIcon}
                                                        style={{ height: '1.5rem', color: '#555' }}
                                                        alt=''
                                                    />
                                                </InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position='end'>
                                                    <p>hrs</p>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginBottom: mediaQueryMobile.matches ? 16 : 30, marginTop: mediaQueryMobile.matches ? 0 : 20 }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        checked={remindRepeatCheckBox}
                                        onChange={(e) => setRemindRepeatCheckBox(e.target.checked)}
                                        label="Repeat After"
                                    />
                                    <TextField
                                        style={{ width: "20px", marginLeft: '10px' }}
                                        disabled={!remindRepeatCheckBox}
                                        variant="standard"
                                        value={reminderSchedule}
                                        onChange={(e) => setReminderSchedule(e.target.value)}
                                    />
                                    <p>Days</p>
                                </div>
                            </div>
                        </>
                    ) : null}
                    <hr style={{ margin: mediaQueryMobile.matches ? '0 0 10px 0' : '20px 0', width: '100%', border: 0, height: 0, borderTop: '1px solid rgb(0, 0, 0, 0.12)' }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30, marginTop: 20, position: 'relative' }}>
                        <div>
                            <p style={{ fontSize: mediaQueryMobile.matches ? 16 : 18, fontWeight: 'bold' }}>Start at</p>
                            <h4 style={{ color: "rgb(150,150,150)", fontWeight: "400" }}>Set test start date and time</h4>
                        </div>
                        {startDateCheckbox &&
                            <TextField
                                style={{ width: 80, margin: '0 1rem', fontSize: mediaQueryMobile.matches ? 12 : 16 }}
                                label="Days"
                                variant="standard"
                                value={testStartDate}
                                onChange={(e) => setTestStartDate(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position='end'>
                                            <CustomDateTimePicker
                                                value={testStartDate}
                                                onChange={(value) => setTestStartDate(value)}
                                            >
                                                <IconButton
                                                    disableRipple
                                                >
                                                    <img
                                                        src={clockIcon}
                                                        style={{ height: '1.5rem', color: '#555' }}
                                                        alt=''
                                                    />
                                                </IconButton>
                                            </CustomDateTimePicker>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        }
                        <div style={{ alignSelf: 'flex-start', zIndex: currentWalkthroughStep === 11 ? 1000 : '', position: 'relative' }}>
                            <Switch
                                id="inviteStep11"
                                checked={startDateCheckbox}
                                onChange={handleStartDateCheckbox}
                            />
                        </div>
                    </div>

                    {/* Deadline time */}
                    <hr style={{ margin: mediaQueryMobile.matches ? '0 0 10px 0' : '20px 0', width: '100%', border: 0, height: 0, borderTop: '1px solid rgb(0, 0, 0, 0.12)' }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30, marginTop: 20, position: 'relative' }}>
                        <div>
                            <p style={{ fontSize: mediaQueryMobile.matches ? 16 : 18, fontWeight: 'bold' }}>Deadline</p>
                            <h4 style={{ color: "rgb(150,150,150)", fontWeight: "400" }}>Set deadline for submission</h4>
                        </div>
                        {deadlineCheckBox &&
                            <TextField
                                style={{ width: 80, margin: '0 1rem', fontSize: mediaQueryMobile.matches ? 12 : 16 }}
                                label="Days"
                                variant="standard"
                                value={deadlineInvite}
                                onChange={(e) => setDeadlineInvite(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position='end'>
                                            <CustomDateTimePicker
                                                value={deadlineInvite}
                                                onChange={(value) => setDeadlineInvite(value)}
                                            >
                                                <IconButton
                                                    disableRipple
                                                >
                                                    <img
                                                        src={clockIcon}
                                                        style={{ height: '1.5rem', color: '#555' }}
                                                        alt=''
                                                    />
                                                </IconButton>
                                            </CustomDateTimePicker>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        }
                        <div style={{ alignSelf: 'flex-start', zIndex: currentWalkthroughStep === 11 ? 1000 : '', position: 'relative' }}>
                            <Switch
                                id="inviteStep11"
                                checked={deadlineCheckBox}
                                onChange={handleDeadlineCheckBox}
                            />
                        </div>
                    </div>
                </div>
                <div className="button-div">
                    <Button
                        id="manageInvitation-selector-12"
                        className="text-transform-none"
                        style={{
                            backgroundColor: '#479BD2',
                            margin: mediaQueryMobile.matches ? '0 0 0 20px' : '0 10px',
                            fontWeight: 'bold',
                            fontFamily: "inherit",
                            letterSpacing: "0.01em",
                            borderRadius: '25px',
                            padding: "6px 20px",
                            fontSize: mediaQueryMobile.matches ? 14 : 16,
                        }}
                        size="small"
                        variant="contained"
                        disabled={handleInviteModalValidation()}
                        onClick={sendTest}
                    >
                        Invite now
                    </Button>
                    <div
                        id="manageInvitation-selector-6"
                        className="invite-later-btn"
                    >
                        <div className="invite-later-text" onClick={onClose}>Invite later</div>
                        {showScheduleInvite
                            ?
                            <img
                                id='manageInvitation-selector-30'
                                src={ArrowUp}
                                alt='solid-arrow-up-icon'
                                className="arrowdropdownicon"
                                onClick={() => setShowScheduleInvite(false)}
                            />
                            :
                            <img
                                id='manageInvitation-selector-29'
                                src={ArrowDown}
                                alt='solid-arrow-down-icon'
                                className="arrowdropdownicon"
                                onClick={() => setShowScheduleInvite(true)}
                            />
                        }
                        <div className="schedule-invite-box" style={{ display: showScheduleInvite ? 'flex' : 'none' }} onClick={onOpenScheduleInviteModal}>
                            <img src={clockIcon} alt="schedule-icon" />
                            <p>Schedule Invite</p>
                        </div>
                    </div>
                </div>
                {
                    currentWalkthroughStep > 7 && currentWalkthroughType === 'invite' && showWalkthrough ? (
                        <WalkthroughOverlay
                            showWalkthroughBackBtn={currentWalkthroughStep !== 8}
                            onClickBack={() => {
                                updateCurrentWalkthroughStep(currentWalkthroughStep - 1);
                            }}
                        />
                    ) : null
                }
            </Modal>
            <Modal
                open={scheduleInviteModal}
                onClose={onCloseScheduleInviteModal}
                classNames={{ modal: 'scheduleInviteModal' }}
                center
            >
                <div className="modal-heading-workflow">
                    Schedule Invite
                </div>
                <p className="schedule-subheading">To schedule your invite manually select a date and time in the future to invite your candidate.</p>
                <div className="date-time-box">
                    <div>
                        <TextField
                            id="manageInvitation-selector-31"
                            label="Date"
                            type="date"
                            value={scheduleInviteParams.date}
                            sx={{ width: 220 }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                style: { padding: '0.5rem 0.8rem' }
                            }}
                            onChange={(e) => setScheduleInviteParams({ ...scheduleInviteParams, date: e.target.value })}
                        />
                    </div>
                    <div>
                        <TextField
                            id="manageInvitation-selector-32"
                            label="Time"
                            type="time"
                            value={scheduleInviteParams.time}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                step: 300,
                                style: { padding: '0.5rem 0.8rem' }
                            }}
                            sx={{ width: 150 }}
                            onChange={(e) => setScheduleInviteParams({ ...scheduleInviteParams, time: e.target.value })}
                        />
                    </div>
                </div>
                <div className="schedule-invite-btns-box">
                    <div className="cancel-button" onClick={onCloseScheduleInviteModal}>Cancel</div>
                    <div className="schedule-btn" onClick={() => sendInvteSchedule()} id="manageInvitation-selector-33">Schedule</div>
                </div>
            </Modal>
        </>
    )
}

const mapStateToProps = createStructuredSelector({
    userPlan: getUserPlan(),
    companyFeatures: getCompanyFeatures(),
    saasPlanDetails: getSaasPlanDetails(),
    currentWalkthroughStep: getCurrentWalkthroughStep(),
    currentWalkthroughType: getCurrentWalkthroughType(),
    preScreeningBots: getPreScreeningBots()
});

const mapDispatchToProps = (dispatch) => ({
    updateCurrentWalkthroughStep: (data) => dispatch(updateCurrentWalkthroughStepRequest(data)),
    updateWalkthroughFlows: (data) => dispatch(updateWalkthroughFlowsRequest(data)),
    fetchPreScreeningBots: (data) => dispatch(fetchPreScreeningBotsRequest(data)),
    updateCurrentWalkthroughType: (data) => dispatch(updateCurrentWalkthroughTypeRequest(data)),
});

CustomInviteModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    companyFeatures: PropTypes.object,
    userPlan: PropTypes.object,
    saasPlanDetails: PropTypes.object,
    preScreeningBots: PropTypes.array,
    setErrMsg: PropTypes.func,
    handleSnackClick: PropTypes.func,
    currentWalkthroughStep: PropTypes.number,
    currentWalkthroughType: PropTypes.string,
    updateCurrentWalkthroughStep: PropTypes.func,
    change: PropTypes.number,
    setChange: PropTypes.func,
    tempInvObjArr: PropTypes.array,
    showWalkthrough: PropTypes.bool,
    tempRemObjArr: PropTypes.array,
    mailList: PropTypes.array,
    setMailList: PropTypes.func,
    updateCurrentWalkthroughType: PropTypes.func,
    updateWalkthroughFlows: PropTypes.func,
    tempPsInv: PropTypes.array,
    fetchPreScreeningBots: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomInviteModal);
